if (!customElements.get('carimbo-personalizador')) {
  customElements.define(
    'carimbo-personalizador',
    class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;

        this.form = this.closest('form');
        this.texts = [...this.querySelectorAll('[data-text]')];
        this.canvas = this.querySelector('[data-canvas]');

        if (!this.form || !this.texts.length || !this.canvas) return;

        this.ns = this.dataset.nameStamp === 'true';
        this.round = this.dataset.round === 'true';
        this.file = this.querySelector('[data-file]');
        this.icon = this.querySelector('[data-icon]');
        this.status = this.querySelector('[data-preview-status]');
        this.error = this.querySelector('[data-error]');
        this.radios = [...this.querySelectorAll('[data-color]')];

        if (this.ns && !this.icon) return;

        const variantScript = this.querySelector('[data-variants]');
        if (!variantScript) return;

        try {
          this.variantData = JSON.parse(variantScript.textContent);
        } catch (error) {
          if (this.status) {
            this.status.textContent =
              'Não foi possível carregar a personalização.';
          }
          return;
        }

        this.ready = true;
        this.form.enctype = 'multipart/form-data';
        this.buildIcons();

        if (this.ns) {
          this.sprite = new Image();
          this.sprite.crossOrigin = 'anonymous';

          this.sprite.onload = () => {
            if (this.isConnected) this.draw();
          };

          this.sprite.onerror = () => {
            if (this.isConnected) this.draw();
          };

          this.sprite.src = this.dataset.sprite;
        }

        this.onInput = () => {
          this.texts[0].setCustomValidity('');

          if (this.icon) {
            this.icon.setCustomValidity('');
          }

          this.sync(true);
        };

        this.onFile = () => this.loadFile();

        this.onSubmit = event => {
          this.sync(true);

          const hasText = this.texts.some(
            input => input.value.trim()
          );

          const hasFile = Boolean(this.file?.files?.length);

          this.texts[0].setCustomValidity(
            this.ns
              ? (
                  hasText
                    ? ''
                    : 'Indique o nome.'
                )
              : (
                  hasText || hasFile
                    ? ''
                    : 'Indique o texto ou anexe o conteúdo pretendido.'
                )
          );

          if (this.icon) {
            this.icon.value = this.icon.value
              .trim()
              .toUpperCase();

            // A grelha do produto é a referência para a escolha.
            // O mapa de recortes não valida disponibilidade de produção.
            this.icon.setCustomValidity(
              this.icon.value
                ? ''
                : 'Indique o código do ícone da grelha do produto.'
            );
          }

          if (!this.form.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };

        this.onFormData = event => {
          if (this.file && !this.file.files.length) {
            event.formData.delete(this.file.name);
          }

          if (this.ns) {
            event.formData.set(
              this.texts[0].name,
              this.texts[0].value.trim()
            );

            event.formData.set(
              this.icon.name,
              this.icon.value.trim().toUpperCase()
            );
          }
        };

        this.addEventListener('input', this.onInput);

        this.file?.addEventListener(
          'change',
          this.onFile
        );

        this.form.addEventListener(
          'submit',
          this.onSubmit,
          true
        );

        this.form.addEventListener(
          'formdata',
          this.onFormData
        );

        this.sync(true);

        this.timer = setInterval(
          () => this.sync(false),
          300
        );

        if (this.file?.files?.length) {
          this.loadFile();
        }
      }

      buildIcons() {
        // Recortes da grelha anterior, apenas para referência.
        // Não validam a disponibilidade dos ícones para produção.
        this.icons = {};

        const xs = [
          294, 366, 437, 510, 582,
          654, 726, 798, 870, 942
        ];

        const groups = [
          ['NA', 16, 63, 139],
          ['NB', 14, 222, 302],
          ['NC', 6, 384],
          ['ND', 6, 464],
          ['NF', 18, 540, 620],
          ['NG', 14, 704, 783],
          ['NK', 18, 861, 941]
        ];

        groups.forEach(
          ([prefix, count, firstY, secondY]) => {
            for (let i = 0; i < count; i++) {
              const code =
                prefix + String(i + 1).padStart(2, '0');

              this.icons[code] = {
                x: xs[i % 10],
                y: i < 10 ? firstY : secondY
              };
            }
          }
        );
      }

      sync(force) {
        const id =
          this.form.querySelector('[name="id"]')?.value ||
          String(this.variantData.initial);

        const variant = this.variantData.variants.find(
          item => item.id === String(id)
        );

        const options = variant?.options || [];

        const choice =
          !this.ns &&
          options.includes('Cor à escolha');

        const wrapper =
          this.querySelector('[data-colors]');

        if (wrapper) {
          wrapper.hidden = !choice;
        }

        this.radios.forEach(radio => {
          radio.disabled = !choice;
          radio.required = choice;
        });

        const chosen = this.radios.find(
          radio => radio.checked
        );

        const fixedColour = options.find(
          value =>
            ['Preto', 'Verde', 'Vermelho', 'Azul']
              .includes(value)
        );

        this.inkName = this.ns
          ? 'Preto'
          : choice
            ? (chosen?.value || '')
            : (fixedColour || '');

        this.ink = {
          Preto: '#111111',
          Verde: '#15803d',
          Vermelho: '#c62828',
          Azul: '#174ea6'
        }[this.inkName] || '';

        const fixed =
          this.querySelector('[data-fixed-color]');

        if (fixed) {
          fixed.hidden = choice || !this.inkName;
          fixed.textContent =
            'Tinta: ' + this.inkName.toLowerCase();
        }

        this.waitingColour = choice && !chosen;

        const key = id + '/' + this.inkName;

        if (force || key !== this.lastKey) {
          this.lastKey = key;
          this.draw();
        }
      }

      loadFile() {
        if (!this.file) return;

        this.texts[0].setCustomValidity('');
        this.file.setCustomValidity('');
        this.error.hidden = true;

        if (this.url) {
          URL.revokeObjectURL(this.url);
        }

        this.url = null;
        this.logo = null;

        const file = this.file.files[0];

        if (!file) {
          this.draw();
          return;
        }

        const extension = file.name
          .split('.')
          .pop()
          .toLowerCase();

        let message = '';

        if (
          !['pdf', 'svg', 'png', 'jpg', 'jpeg']
            .includes(extension)
        ) {
          message = 'Escolha PDF, SVG, PNG ou JPG.';
        } else if (file.size > 10 * 1024 * 1024) {
          message = 'O ficheiro não pode exceder 10 MB.';
        }

        if (message) {
          this.file.setCustomValidity(message);
          this.error.textContent = message;
          this.error.hidden = false;
          this.draw();
          return;
        }

        if (
          ['png', 'jpg', 'jpeg'].includes(extension)
        ) {
          const image = new Image();
          const url =
            this.url = URL.createObjectURL(file);

          image.onload = () => {
            if (
              this.isConnected &&
              this.url === url
            ) {
              this.logo = image;
              this.draw();
            }
          };

          image.onerror = () => {
            if (this.url !== url) return;

            const error =
              'Não foi possível ler esta imagem. Escolha outro ficheiro.';

            this.file.setCustomValidity(error);
            this.error.textContent = error;
            this.error.hidden = false;
            this.draw();
          };

          image.src = url;
        }

        this.draw();
      }

      drawContained(ctx, image, x, y, width, height) {
        const originalWidth =
          image.naturalWidth || image.width;

        const originalHeight =
          image.naturalHeight || image.height;

        if (!originalWidth || !originalHeight) return;

        const scale = Math.min(
          width / originalWidth,
          height / originalHeight
        );

        const drawnWidth = originalWidth * scale;
        const drawnHeight = originalHeight * scale;

        // Imagem original, sem cortar, deformar ou recolorir.
        ctx.drawImage(
          image,
          x + (width - drawnWidth) / 2,
          y + (height - drawnHeight) / 2,
          drawnWidth,
          drawnHeight
        );
      }

      drawText(ctx, lines, x, y, width, height) {
        if (!lines.length) return;

        let size = Math.min(
          70,
          height / (lines.length * 1.3)
        );

        ctx.font = `600 ${size}px Arial`;

        while (
          size > 1 &&
          lines.some(
            line => ctx.measureText(line).width > width
          )
        ) {
          size -= 1;
          ctx.font = `600 ${size}px Arial`;
        }

        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const step = size * 1.3;

        lines.forEach((line, index) => {
          ctx.fillText(
            line,
            x + width / 2,
            y + height / 2 +
              (index - (lines.length - 1) / 2) * step
          );
        });
      }

      drawNameStamp(ctx) {
        const name = this.texts[0].value.trim();

        const code = this.icon.value
          .trim()
          .toUpperCase();

        const crop = this.icons[code];

        const W = this.canvas.width;
        const H = this.canvas.height;

        ctx.strokeStyle = '#888';
        ctx.lineWidth = 3;
        ctx.fillStyle = '#111';

        const hasIconPreview =
          crop &&
          this.sprite?.complete &&
          this.sprite.naturalWidth;

        const drawIcon = (x, y, size) => {
          if (!hasIconPreview) return;

          const sx =
            this.sprite.naturalWidth / 1000;

          const sy =
            this.sprite.naturalHeight / 1000;

          ctx.imageSmoothingEnabled = true;

          ctx.drawImage(
            this.sprite,
            (crop.x - 18) * sx,
            (crop.y - 18) * sy,
            36 * sx,
            36 * sy,
            x,
            y,
            size,
            size
          );
        };

        if (this.round) {
          // QN32: cercle, ícone em cima e nome em baixo.
          // Composição apenas ilustrativa.
          ctx.beginPath();
          ctx.arc(
            W / 2,
            H / 2,
            W / 2 - 8,
            0,
            Math.PI * 2
          );
          ctx.stroke();

          const iconSize = W * 0.36;

          if (hasIconPreview) {
            drawIcon(
              (W - iconSize) / 2,
              H * 0.18,
              iconSize
            );
          } else {
            this.drawText(
              ctx,
              [code || 'Ícone'],
              W * 0.22,
              H * 0.23,
              W * 0.56,
              H * 0.25
            );
          }

          this.drawText(
            ctx,
            [name || 'O seu nome'],
            W * 0.18,
            H * 0.60,
            W * 0.64,
            H * 0.18
          );
        } else {
          // QN41: retângulo, ícone à esquerda e nome à direita.
          // Composição apenas ilustrativa.
          ctx.strokeRect(
            3,
            3,
            W - 6,
            H - 6
          );

          const pad = H * 0.08;
          const iconSize = H * 0.84;
          const textX = pad + iconSize + pad;

          if (hasIconPreview) {
            drawIcon(
              pad,
              (H - iconSize) / 2,
              iconSize
            );
          } else {
            this.drawText(
              ctx,
              [code || 'Ícone'],
              pad,
              pad,
              iconSize,
              H - 2 * pad
            );
          }

          this.drawText(
            ctx,
            [name || 'O seu nome'],
            textX,
            pad,
            W - textX - pad,
            H - 2 * pad
          );
        }

        let message = this.round
          ? 'Formato redondo Ø13 mm. Pré-visualização ilustrativa, não à escala.'
          : 'Formato retangular 9,5 × 46 mm. Pré-visualização ilustrativa, não à escala.';

        message +=
          ' A composição final está sujeita ao modelo e à área de impressão.';

        if (!hasIconPreview) {
          message += code
            ? ' Sem recorte disponível para este código; consulte a grelha do produto.'
            : ' Indique o código do ícone da grelha do produto.';
        }

        this.status.textContent = message;
      }

      draw() {
        if (!this.canvas) return;

        if (this.waitingColour) {
          this.canvas.hidden = true;
          this.status.textContent =
            'Selecione verde, vermelho ou azul para visualizar.';
          return;
        }

        this.canvas.hidden = false;

        const width = Number(this.dataset.width);
        const height = Number(this.dataset.height);

        const hasDimensions =
          width > 0 && height > 0;

        const W = this.canvas.width = 900;

        const H = this.canvas.height = this.ns
          ? (
              this.round
                ? 900
                : Math.round(900 * 9.5 / 46)
            )
          : (
              hasDimensions
                ? Math.round(W * height / width)
                : 450
            );

        const ctx = this.canvas.getContext('2d');
        if (!ctx) return;

        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, W, H);

        if (this.ns) {
          this.drawNameStamp(ctx);
          return;
        }

        const lines = this.texts.flatMap(
          input => input.value.split(/\r?\n/)
        );

        // Preservar linhas vazias intermédias.
        // Remover apenas vazios no início e no fim.
        while (
          lines.length &&
          !lines[0].trim()
        ) {
          lines.shift();
        }

        while (
          lines.length &&
          !lines[lines.length - 1].trim()
        ) {
          lines.pop();
        }

        const textLines = lines.map(
          line => line.trim()
        );

        ctx.fillStyle = this.ink || '#555';
        ctx.strokeStyle = '#bbb';
        ctx.lineWidth = 2;

        if (hasDimensions) {
          if (this.round) {
            ctx.beginPath();
            ctx.arc(
              W / 2,
              H / 2,
              Math.min(W, H) / 2 - 4,
              0,
              Math.PI * 2
            );
            ctx.stroke();
          } else {
            ctx.strokeRect(
              2,
              2,
              W - 4,
              H - 4
            );
          }
        }

        const picture = this.logo;

        if (this.round && hasDimensions) {
          // Referência em linhas direitas, nunca em arco.
          // Caixa do logótipo: 42% do diâmetro.
          const logoSize = W * 0.42;

          if (picture && textLines.length) {
            this.drawContained(
              ctx,
              picture,
              (W - logoSize) / 2,
              H * 0.12,
              logoSize,
              logoSize
            );

            this.drawText(
              ctx,
              textLines,
              W * 0.19,
              H * 0.60,
              W * 0.62,
              H * 0.23
            );
          } else if (picture) {
            this.drawContained(
              ctx,
              picture,
              (W - logoSize) / 2,
              (H - logoSize) / 2,
              logoSize,
              logoSize
            );
          } else {
            this.drawText(
              ctx,
              textLines.length
                ? textLines
                : ['O seu texto'],
              W * 0.16,
              H * 0.16,
              W * 0.68,
              H * 0.68
            );
          }
        } else {
          const pad = Math.min(
            H * 0.08,
            W * 0.05
          );

          if (picture && textLines.length) {
            // Caixa do logótipo aumentada.
            // Mantém as proporções e as cores originais.
            const logoWidth = Math.min(
              H * 1.1,
              W * 0.35
            );

            const logoHeight = H * 0.84;

            this.drawContained(
              ctx,
              picture,
              pad,
              (H - logoHeight) / 2,
              logoWidth,
              logoHeight
            );

            const textX =
              pad + logoWidth + pad;

            this.drawText(
              ctx,
              textLines,
              textX,
              pad,
              W - textX - pad,
              H - 2 * pad
            );
          } else if (picture) {
            this.drawContained(
              ctx,
              picture,
              pad,
              pad,
              W - 2 * pad,
              H - 2 * pad
            );
          } else {
            this.drawText(
              ctx,
              textLines.length
                ? textLines
                : ['O seu texto'],
              pad,
              pad,
              W - 2 * pad,
              H - 2 * pad
            );
          }
        }

        let message =
          'Referência ilustrativa do conteúdo. A disposição final depende do modelo e da área de impressão.';

        if (
          this.file?.files.length &&
          !this.logo
        ) {
          message +=
            ' O anexo não é desenhado nesta pré-visualização.';
        }

        if (!hasDimensions) {
          message +=
            ' O painel não representa as dimensões do modelo.';
        }

        this.status.textContent = message;
      }

      disconnectedCallback() {
        if (!this.ready) return;

        clearInterval(this.timer);

        if (this.url) {
          URL.revokeObjectURL(this.url);
        }

        this.removeEventListener(
          'input',
          this.onInput
        );

        this.file?.removeEventListener(
          'change',
          this.onFile
        );

        this.form.removeEventListener(
          'submit',
          this.onSubmit,
          true
        );

        this.form.removeEventListener(
          'formdata',
          this.onFormData
        );

        this.ready = false;
      }
    }
  );
}